export function catchError(target: any, propertyName: string, descriptor: PropertyDescriptor) {
    const method = descriptor.value;

    descriptor.value = async function (...args: any[]) {
        try {
            return await method.apply(this, args);
        } catch (error) {
            console.error(`Error in method ${propertyName}:`, error);
        }
    };
}

export function catchErrorAndLog(target: any, propertyName: string, descriptor: PropertyDescriptor) {
    const method = descriptor.value;

    descriptor.value = async function (...args: any[]) {
        try {
            return await method.apply(this, args);
        } catch (error) {
            (window as any)[Symbol.for('rcx_sentry')]?.captureException({
                error,
                method: propertyName,
                args,
            });
        }
    };
}
